<script>
    import {hideLightBox, lightbox_manager} from "../stores/misc";

    let display_in = false;
    let display_out = false;

    $: {
        switch($lightbox_manager.visible) {
            case true:
                display_in = true;
                setTimeout(() => display_out = true, 1);
                break;
            case false:
                setTimeout(() => display_in = false, 200);
                display_out = false;
                break;
        }
    }
</script>

<div class="{display_in ? '' : 'hidden'} relative z-10" role="dialog" aria-modal="true">
    <!--
      Background backdrop, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="{display_out ? `ease-out duration-300 opacity-100` : `ease-in duration-200 opacity-0`} fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity hidden md:block"></div>

    <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex min-h-full w-full items-stretch justify-center text-center md:items-center md:px-2 lg:px-4">
            <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden md:inline-block md:h-screen md:align-middle" aria-hidden="true">&#8203;</span>

            <!--
              Modal panel, show/hide based on modal state.

              Entering: "ease-out duration-300"
                From: "opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
                To: "opacity-100 translate-y-0 md:scale-100"
              Leaving: "ease-in duration-200"
                From: "opacity-100 translate-y-0 md:scale-100"
                To: "opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
            -->
            <div class="flex justify-center w-full transform {display_out ? `ease-out duration-300 opacity-100 translate-y-0 md:scale-100` : `ease-in duration-200 opacity-0 translate-y-4 md:translate-y-0 md:scale-95`} text-left text-base transition md:my-8 xmd:max-w-2xl md:px-4 xlg:max-w-4xl">
                <div class="relative flex justify-center w-full max-w-7xl items-center overflow-hidden bg-white px-4 pt-14 pb-8 shadow-2xl sm:px-12 sm:pt-12 md:p-12 lg:p-14">
                    <button on:click={() => hideLightBox()} type="button" class="absolute top-4 right-4 text-gray-400 hover:text-gray-500 sm:top-4 sm:right-4 md:top-4 md:right-4 lg:top-6 lg:right-6">
                        <span class="sr-only">Close</span>
                        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>

<!--                    <div class="grid w-full grid-cols-1 items-start gap-y-8 gap-x-6 sm:grid-cols-12 lg:items-center lg:gap-x-8">-->
                    <div class="xw-full flex items-start justify-center lg:items-center">
                        <div class="xaspect-w-2 xaspect-h-3 overflow-hidden rounded-lg bg-gray-100 max-h-[85vh] xsm:col-span-4 xlg:col-span-5">
                            <img src="{$lightbox_manager.img_url}" class="xobject-cover xobject-center max-h-[85vh]">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style></style>